export const name = "TRANSLATE";
export const summary = `Within a value, replaces each source character with the corresponding target character.`;
export const reference = `
## TRANSLATE

Within a value, replaces each source character with the corresponding target character.

\`\`\`
TRANSLATE(expression, source_characters, target_characters)
\`\`\`

### Description

In \`expression\`, replaces each character in \`source_characters\` with the corresponding character in \`target_characters\`. All inputs must be the same type, either \`STRING\` or \`BYTES\`.

- Each character in \`expression\` is translated at most once.
- A character in \`expression\` that isn't present in \`source_characters\` is left unchanged in \`expression\`.
- A character in \`source_characters\` without a corresponding character in\`target_characters\` is omitted from the result.
- A duplicate character in \`source_characters\` results in an error.


### Return type

\`STRING\` or \`BYTES\`


### Examples



\`\`\`
SELECT TRANSLATE('This is a cookie', 'sco', 'zku') AS translate

/*------------------*
 | translate |
 +------------------+
 | Thiz iz a kuukie |
 *------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
